<template>
  <!--  添加和编辑项目  -->
  <el-dialog title="项目记工统计" :visible.sync="show" width="600px" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
    <div style="max-height: 500px;overflow-y: auto">
      <div class="card" v-for="(item,i) in list" :key="i">
        <div class="c_title">{{item.projectName}}<span class="c_button" @click="show=false;$emit('closeend',item.projectNo)">查看详情</span></div>
        <div style="padding: 0 10px">
          <div class="c_contex_dg" v-if="item.pointWorkStatistics">
            <div class="dg_center"><span>点工</span></div>
            <div>
              <div v-if="tosb(item)"><span style="color: #666">上班：</span>{{tosb(item)}}</div>
              <div><span style="color: #666">加班：</span>{{ item.workOverHourAll }}小时</div>
            </div>
          </div>
          <div v-if="(item.wrapWorkStatistics&&item.pointWorkStatistics)" style="border-top: 1px #E4E7ED dashed;"/>
          <div class="c_contex_bg" v-if="item.wrapWorkStatistics">
            <div>包工(按量记)</div>
            <div>{{ item.wrapWorkNum }}笔</div>
            <div class="bg_color">￥{{ item.salaryAll }}元</div>
          </div>
          <div v-if="!(item.wrapWorkStatistics||item.pointWorkStatistics)" class="c_contex_null">暂无记工</div>
        </div>
      </div>
    </div>
    <div v-if="!list.length">
      <div class="nodata">
        <img :src="require('@/assets/zanwushuju-2@2x.png')" height="177" width="177"/>
        <div class="nodatatext">暂无数据</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {api} from '@/api/apiRecord.js'
export default {
  name: "projectCount",
  components: {
  },
  data(){
    return {
      show:false,
      loading:false,
      list:[],
      type:this.$route.query.type?this.$route.query.type:1,//当前页面进入模式1.个人记工2.班组记工
    }
  },
  watch:{
    show(v){
      if(v)this.getlist();
    }
  },
  methods:{
    async getlist(){
      let res=await api.getWorkStatistics({recordType:this.type,projectNo:''});
      if(res.data.code==200){
        this.list=this.computlist(res.data.data);
      }
    },
    computlist(data){
      let arr=[];
      let {projectSortList,pointWorkStatisticsList,wrapWorkStatisticsList}=data;
      let listobj={};
      //创建项目记录对象
      projectSortList.forEach(v=>{
        let {projectNo,projectName}=v;
        listobj[projectNo]={projectNo,projectName}
      })
      //获取项目点工信息
      pointWorkStatisticsList.forEach(v=>{
        v.pointWorkStatistics=true;
        listobj[v.projectNo]={...listobj[v.projectNo],...v}
      })
      //获取项目包工信息
      wrapWorkStatisticsList.forEach(v=>{
        v.wrapWorkStatistics=true;
        listobj[v.projectNo]={...listobj[v.projectNo],...v}
      })
      //排序项目记录
      projectSortList.forEach(v=>{
        arr.push(listobj[v.projectNo])
      })
      return arr;
    },
    tosb(item){
      let str=''
      if(item.workDayAll){
        str+=`${item.workDayAll}个工`
      }
      if(item.workHourAll){
        if(str)str+=',';
        str+=`${item.workHourAll}小时`
      }
      return str;
    }
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body{
  padding-top: 20px;
}
.card{
  border: 1px solid #E4E7ED;
  border-radius: 2px;
  font-size: 14px;
  margin-bottom: 20px;
  .c_title{
    padding: 0 10px;
    line-height: 40px;
    background: #F5F7FA;
    .c_button{
      float: right;
      cursor: pointer;
      color: #0286DF;
    }
  }
  .c_contex_dg{
    display: flex;
    line-height: 32px;
    div{
      flex: 1;
    }
    .dg_center{
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
  }
  .c_contex_bg{
    display: flex;
    line-height: 50px;
    div{
      flex: 1;
      align-items: center;
    }
    .bg_color{
      color: #FF6600;
      font-size: 16px;
    }
  }
  .c_contex_null{
    line-height: 50px;
    text-align: center;
    color: #666666;
  }
}
.nodata{
  width: 100%;
  height: 423px;
  text-align: center;
  img{
    margin-top: 100px;
    margin-bottom: 30px;
  }
  .nodatatext{
    font-size: 16px;
    color:#666666
  }
}
</style>
